import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  ul: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  li: {
    marginBottom: 5,
    '& ul': {
      marginLeft: 20,
      [theme.breakpoints.down(theme.size.sm)]: {
        marginLeft: 10,
      },
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  bar: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  mock: {
    width: 22,
    height: 22,
    opacity: 0,
  },
  mainIcon: {
    marginRight: 7,
    color: 'lightgrey',
    fontSize: '1.5rem',
  },
  text: {
    marginLeft: 7,
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
}));
